import React from 'react';
import fr from 'facet-rest';
import { useIdentityChallengeContext } from 'Context/IdentityChallengeContext';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { FDTextButton } from '@facet-wealth/design';


const BackToChallengeButton = () => {
  const { displayErrorMessage } = useSnackbarContext();
  const { challengeFlowResource, setChallengeFlowCollection } = useIdentityChallengeContext();
  const handleClick = async () => {
    try {
      const coll = await challengeFlowResource.withRelationship(fr.relationships.currentMfaChallenge.name,
        (rel) => rel.link('related').get(),
        () => {
          throw new Error('Did not find mfa challenge relationship, this should never happen');
        });
      if (coll) {
        setChallengeFlowCollection(coll);
      }
    } catch (err) {
      displayErrorMessage(err, `Unable to send code to ${challengeFlowResource.attr('sentTo')}. Please contact a Facet team member.`);
    }
  };

  return (
    <FDTextButton label={'Go Back'} onClick={handleClick} />
  );
};

BackToChallengeButton.defaultProps = {
};

BackToChallengeButton.propTypes = {
};

export default BackToChallengeButton;
